import { SimilarJobData } from '@xing-com/crate-jobs-helpers';

export const orderSimilarJobs = ({
  isTopSimilarJobsPriorized,
  similarJobs,
}: {
  isTopSimilarJobsPriorized: boolean;
  similarJobs: SimilarJobData[];
}): SimilarJobData[] => {
  if (!isTopSimilarJobsPriorized) return similarJobs;

  const topJobs = similarJobs.filter(({ job }) => job.topJob);
  const paidAndExternalJobs = similarJobs.filter(
    ({ job }) => !job.topJob && (job.paid || job.redirectsToThirdPartyUrl)
  );
  const unpaid = similarJobs.filter(
    ({ job }) => !job.topJob && !job.paid && !job.redirectsToThirdPartyUrl
  );
  return [...topJobs, ...paidAndExternalJobs, ...unpaid];
};
